var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('info-tab',{attrs:{"title":[].concat( _vm.title )}},[_vm._t("default",null,{"slot":"content_0"}),_vm._t("rightHeader",null,{"slot":"right_0"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }